// src/pages/PublicCatalog/utils.js

export const formatPrice = (price) => {
    const numPrice = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(numPrice)) return '0.00';
    return numPrice.toFixed(2);
};

export const formatMessage = (cartItems, total) => {
    return "```🛒Nuevo Pedido\n\n```" + `${cartItems.map(item => 
        `• ${item.name} : ID${item.id}\n  ${item.quantity}x $${formatPrice(item.price)} = $${formatPrice(item.subtotal)}`
    ).join('\n\n')}\n\n*💰Total: ${formatPrice(total)}*`;
};

export const validatePhoneNumber = (phone) => {
    return /^\d{12}$/.test(phone);
};

export const validateCountryCode = (code) => {
    return /^\d{1,4}$/.test(code);
};